
var toggleVisibility = function(evt) {
  let classes = evt.target.nextElementSibling.classList;
  classes.contains('w3-show') ? classes.replace('w3-show', 'w3-hide') : classes.replace('w3-hide', 'w3-show');
};

/**
 * @param {String}
 * @param {Element}
 * @return {Element}
 */
export default function(label, content, expanded) {
  let container = document.createElement('div');
  let toggle = document.createElement('div');

  container.classList.add('collapsable-container');
  toggle.classList.add('collapsable-toggle');
  toggle.innerText = label;
  toggle.addEventListener('click', toggleVisibility);
  content.classList.add('collapsable-content');
  content.classList.add(expanded ? 'w3-show' : 'w3-hide');
  container.append(toggle, content);
  return container;
}
